module.exports = __webpack_public_path__ + "static/media/bg-kids-standby.29f9b08c.svg";